import React from "react";

export default function Preloader(){
    return(
        <div className="preloader">
            <div className="version">v 1.0.0</div>
            <div className="preloader-circle"></div>
        </div>
    )
}